import { Button, Grid2, styled, Typography } from "@mui/material"
import NoInternet from "src/assets/icons/nointernet.svg"
import { blueGrey } from "@mui/material/colors"
import SvgIcon from "src/shared/components/SvgIcon"
import { useTranslation } from "react-i18next"

const MainContainer = styled(Grid2)(() => ({
  textAlign: "center",
  minHeight: "100vh",
  padding: "12px 24px",
  backgroundColor: "white"
}))

const Title = styled(Typography)({
  color: blueGrey[500],
  fontSize: 28,
  fontWeight: 600
})

const Subtitle = styled(Typography)({
  color: blueGrey[500]
})

const RetryButton = styled(Button)({
  backgroundColor: blueGrey[500],
  color: "white",
  marginTop: 12
})

function Offline({ retry }: { retry: () => void }) {
  const { t } = useTranslation("error")
  return (
    <MainContainer container alignItems="center" justifyContent="center" direction="column">
      <Grid2 size={{ md: 6, xs: 12 }}>
        <SvgIcon size="140px" src={NoInternet} />
      </Grid2>
      <Grid2 size={{ md: 6, xs: 12 }}>
        <Title fontWeight="bold" fontSize={24}>
          {t("offline.title")}
        </Title>
        <Subtitle variant="body1" fontSize={16}>
          {t("offline.subtitle")}
        </Subtitle>
        <RetryButton
          size="medium"
          variant="contained"
          onClick={() => {
            retry()
            window.location.reload()
          }}
        >
          Retry Again
        </RetryButton>
      </Grid2>
    </MainContainer>
  )
}

export default Offline
